<template>
  <pt-goods-detail class="pt-goods-detail__page" :id="id"></pt-goods-detail>
</template>

<script>
import PtGoodsDetail from 'cps/mall-manage/pt-goods-manage/pt-goods-detail/withData'
export default {
  name: 'pt-goods-detail__view',
  components: {
    'pt-goods-detail': PtGoodsDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
